import {  Component,SimpleChanges, OnInit, Input, OnChanges, ViewChildren } from '@angular/core';
import {PieChartComponent} from '../../../common-components/charts/pie-chart/pie-chart.component';
import {LineChartComponent} from '../../../common-components/charts/line-chart/line-chart.component';
import { IBasicChart } from 'app/rpa-bots/uipath/common/models/IBasicChart';
import { IDataCharts } from 'app/rpa-bots/uipath/common/models/IDataCharts';
import { ILineChart } from 'app/rpa-bots/uipath/common/models/ILineChart';

@Component({
  selector: 'biz-uipath-queueitem-dashboard',
  templateUrl: './uipath-queueitem-dashboard.component.html',
  styleUrls: ['./uipath-queueitem-dashboard.component.scss']
})
export class UipathQueueitemDashboardComponent implements OnInit, OnChanges {

   dataChartQueueitemStatusLastDay: IBasicChart[];
   dataChartQueueitemStatusLastWeek: IBasicChart[];
   dataChartQueueitemStatusLastMonth: IBasicChart[];
   dataChartQueueitemStatusLastYear: ILineChart;

   @Input() tabIndex:number;
   @Input() dataQueueitemsChart: IDataCharts;

   @ViewChildren(PieChartComponent) pieChartList: PieChartComponent[];
   @ViewChildren(LineChartComponent) lineChart: LineChartComponent[];

   private listTimeOut: any[] = [];


  emptyChart: IBasicChart[] = [{
    letter: 'Empty Data',
    frequency: 1
  }]

  constructor() {

  }

  public refresh(){
    if(this.pieChartList && this.lineChart){
      this.listTimeOut.push(setTimeout(()=>{
        this.pieChartList.forEach((chart: PieChartComponent)=>{
          chart.refresh();
        });

        this.lineChart.forEach((chart: LineChartComponent)=>{
          chart.refresh();
        });
      }));
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.dataQueueitemsChart && changes.dataQueueitemsChart.currentValue) {
        this.dataChartQueueitemStatusLastDay = this.dataQueueitemsChart.LastDayData;
        this.dataChartQueueitemStatusLastWeek = this.dataQueueitemsChart.LastWeekData;
        this.dataChartQueueitemStatusLastMonth = this.dataQueueitemsChart.LastMonthData;
        this.dataChartQueueitemStatusLastYear = this.dataQueueitemsChart.LastYearData;
    }
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.listTimeOut.forEach(timeOut => clearTimeout(timeOut));
  }
}
